/* eslint-disable no-param-reassign */
import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['ExternalAgencyShifts']
});

const externalAgencyShiftsAPI = apiWithTags.injectEndpoints({
	tagTypes: ['ExternalAgencyShifts'],
	endpoints: (build) => ({
		externalAgencyOpenShifts: build.query({
			query: ({ start, end }) => `/agencies/shifts?start=${start}&end=${end}`,
			providesTags: ['ExternalAgencyShifts']
		}),
		externalAgencyAssignedShifts: build.query({
			query: () => `/agencies/assigned-shifts`,
			providesTags: ['ExternalAgencyShifts']
		}),
		externalAgencyPastShifts: build.query({
			query: ({ start, end }) => `/agencies/past-shifts?start=${start}&end=${end}`,
			providesTags: ['ExternalAgencyShifts']
		}),
		assignExternalProfessional: build.mutation({
			query: ({ shiftId, caregiverId, shiftData, recurringShiftData, byPassOTModalConfirmation }) => ({
				url: `/agencies/shifts/${shiftId}/assign-professional/${caregiverId}`,
				method: 'POST',
				body: { shiftData, recurringShiftData, byPassOTModalConfirmation }
			}),
			providesTags: ['ExternalAgencyShifts']
		}),
		cancelShift: build.mutation({
			query: ({ slotId, caregiverId, callOutReason, action }) => ({
				url: `/agencies/shifts/cancel/${slotId}`,
				method: 'POST',
				body: {
					caregiverId,
					callOutReason,
					action
				}
			}),
			providesTags: ['ExternalAgencyShifts']
		}),
		assignExternalBundleProfessional: build.mutation({
			query: ({ bundleId, caregiverId, shiftsData, byPassOTModalConfirmation }) => ({
				url: `/agencies/bundle/${bundleId}/assign-professional/${caregiverId}`,
				method: 'POST',
				body: { shiftsData, byPassOTModalConfirmation }
			}),
			providesTags: ['ExternalAgencyShifts']
		}),
		externalAgencyOpenBundles: build.query({
			query: ({ start, end }) => `/agencies/bundles?start=${start}&end=${end}`,
			providesTags: ['ExternalAgencyShifts']
		}),
		externalAgencyBundleShifts: build.query({
			query: (bundleId) => `/agencies/bundle/${bundleId}`,
			providesTags: ['ExternalAgencyShifts']
		})
	})
});

export const {
	useExternalAgencyOpenShiftsQuery,
	useExternalAgencyAssignedShiftsQuery,
	useExternalAgencyPastShiftsQuery,
	useAssignExternalProfessionalMutation,
	useAssignExternalBundleProfessionalMutation,
	useExternalAgencyOpenBundlesQuery,
	useExternalAgencyBundleShiftsQuery,
	useCancelShiftMutation
} = externalAgencyShiftsAPI;

export default externalAgencyShiftsAPI;
